/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkLogDto } from '../../models/create-work-log-dto';
import { WorkLog } from '../../models/work-log';

export interface WorkLogsControllerCreate$Params {
      body: CreateWorkLogDto
}

export function workLogsControllerCreate(http: HttpClient, rootUrl: string, params: WorkLogsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkLog>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkLog>;
    })
  );
}

workLogsControllerCreate.PATH = '/work-logs';
